/**
 * Messaggio utente da un payload di errore HTTP.
 *
 * Il backend usa due buste: quella canonica `{ error: { code, message } }`
 * (o `{ error: string }`) e quella dei middleware di blocco
 * (`{ success:false, code, message }`, es. 423 `inventory_locked`). Il
 * messaggio del server ha sempre la precedenza; «HTTP <status>» resta SOLO
 * quando il corpo non porta alcun testo leggibile.
 */
export function resolveApiErrorMessage(payload: unknown, status: number): string {
  if (typeof payload === 'object' && payload !== null) {
    const body = payload as Record<string, unknown>;
    const error = body.error;
    if (typeof error === 'string' && error.trim()) return error;
    if (typeof error === 'object' && error !== null) {
      const nested = error as Record<string, unknown>;
      if (typeof nested.message === 'string' && nested.message.trim()) return nested.message;
      // Busta degli endpoint AI Routing: `{ error: { code, message_it, hint? } }`.
      if (typeof nested.message_it === 'string' && nested.message_it.trim()) return nested.message_it;
      if (typeof nested.code === 'string' && nested.code.trim()) return nested.code;
    }
    if (typeof body.message === 'string' && body.message.trim()) return body.message;
    if (typeof body.message_it === 'string' && body.message_it.trim()) return body.message_it;
    if (error !== undefined && error !== null) return JSON.stringify(error);
  }
  return `HTTP ${status}`;
}
